import { render, staticRenderFns } from "./NoContentBox.vue?vue&type=template&id=11ec1722&"
import script from "./NoContentBox.vue?vue&type=script&lang=js&"
export * from "./NoContentBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports